const STORAGE_KEY = 'nido:hidden-properties';

export function getHiddenPropertyIds(userId) {
  if (!userId) return [];

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    const userHidden = Array.isArray(data[userId]) ? data[userId] : [];
    return userHidden.filter(Boolean).map(String);
  } catch {
    return [];
  }
}

export function getCurrentUserHiddenKey(user) {
  return user?._id || user?.id || 'anonymous-user';
}

export function isPropertyHidden(propertyId, userId) {
  if (!propertyId || !userId) return false;
  return getHiddenPropertyIds(userId).includes(String(propertyId));
}

export function toggleHiddenProperty(propertyId, userId) {
  if (!propertyId || !userId) return false;

  const nextState = {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const current = raw ? JSON.parse(raw) : {};
    const userHidden = Array.isArray(current[userId]) ? current[userId] : [];
    const normalized = userHidden.map(String);
    const target = String(propertyId);
    const next = normalized.includes(target)
      ? normalized.filter((item) => item !== target)
      : [...normalized, target];

    nextState[userId] = next;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...nextState }));
    return true;
  } catch {
    return false;
  }
}

export function filterHiddenProperties(properties, userId) {
  if (!Array.isArray(properties) || !userId) return properties;
  const hiddenIds = new Set(getHiddenPropertyIds(userId));
  return properties.filter((property) => !hiddenIds.has(String(property?._id || property?.id)));
}
